import request from './request'

export function listMinStockReplenish(data) {
  return request.post('/production/min-stock-replenish/list', data)
}
export function getMinStockReplenish(id) {
  return request.get('/production/min-stock-replenish/' + id)
}
export function generateMinStockReplenish() {
  return request.post('/production/min-stock-replenish/generate', {})
}
